/**
 * SWIST Wishlist
 * localStorage anahtarı: misafir → "wl_guest", üye → "wl_<customerId>"
 * Depolama formatı: [{id: "123456789", handle: "urun-adi", price: 154900, addedAt: 1760000000000}, ...]
 * price: favoriye eklendiği andaki fiyat (kuruş); favoriler sayfası "Fiyatı düştü" için kullanır.
 * Üyelerde liste ayrıca Shopify müşteri kaydına (metafield swist.favoriler) senkronlanır;
 * bkz. layout/theme.liquid ve Desktop/swist-favoriler (Netlify servisi).
 * Favoriler sayfasının kendisi assets/wishlist-page.js'tedir.
 */
(function () {
  'use strict';

  /* ─── Çift yüklenme koruması ──────────────────────────────── */
  if (window.__swistWishlistLoaded) return;
  window.__swistWishlistLoaded = true;

  var STORAGE_PREFIX = 'wl_';
  var GUEST_KEY      = 'wl_guest';
  var EVENT_NAME     = 'wishlist:change';

  /* ─── localStorage'dan oku ────────────────────────────────── */
  function readItems(key) {
    try {
      var raw    = localStorage.getItem(key);
      var parsed = JSON.parse(raw || '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed.map(function (item) {
        return (typeof item === 'string') ? { id: item, handle: '' } : item;
      });
    } catch (e) {
      return [];
    }
  }

  /* ─── localStorage'a yaz ──────────────────────────────────── */
  function writeItems(key, items) {
    try {
      localStorage.setItem(key, JSON.stringify(items));
    } catch (e) { /* sessiz */ }
  }

  /* ─── Depolama anahtarını belirle ─────────────────────────── */
  var customerId = window.__swistCustomerId || null;
  var storageKey = customerId ? (STORAGE_PREFIX + customerId) : GUEST_KEY;

  /* ─── Üye favorileri: Shopify müşteri kaydıyla senkron ─────────
     layout/theme.liquid, giriş yapmış üyeye window.__swistFavSync verir:
     { endpoint, ts, sig, items } — items müşteri kaydındaki liste (hiç
     kaydedilmemişse null). Liste her değişiklikte o servise gönderilir.
     Gönderilemeyen değişiklik "bekliyor" olarak işaretlenir; bir sonraki
     açılışta yerel liste esas alınıp tekrar gönderilir. */
  var sync        = (customerId && window.__swistFavSync && window.__swistFavSync.endpoint) ? window.__swistFavSync : null;
  var PENDING_KEY = storageKey + '_pending';
  var syncTimer   = null;

  /* İlk listenin sırasını koruyarak ikinci listede olup ilkinde olmayanları ekler. */
  function unionItems(first, second) {
    return first.concat(second).reduce(function (acc, item) {
      if (item && item.id && !acc.some(function (i) { return i.id === String(item.id); })) {
        acc.push(Object.assign({}, item, { id: String(item.id) }));
      }
      return acc;
    }, []);
  }

  function sameIds(a, b) {
    return a.length === b.length && a.every(function (item, index) { return item.id === b[index].id; });
  }

  function pushToServer() {
    syncTimer = null;
    if (!sync) return;
    var items = readItems(storageKey);
    fetch(sync.endpoint, {
      method:    'POST',
      keepalive: true,
      /* text/plain: tarayıcı CORS ön kontrolü (preflight) yapmaz */
      headers:   { 'Content-Type': 'text/plain;charset=UTF-8' },
      body:      JSON.stringify({ customerId: String(customerId), ts: sync.ts, sig: sync.sig, items: items })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data && data.ok && sameIds(readItems(storageKey), items)) localStorage.removeItem(PENDING_KEY);
      })
      .catch(function () { /* bekliyor işareti kalır, sonraki açılışta tekrar denenir */ });
  }

  function scheduleSync() {
    if (!sync) return;
    try { localStorage.setItem(PENDING_KEY, '1'); } catch (e) { /* sessiz */ }
    clearTimeout(syncTimer);
    syncTimer = setTimeout(pushToServer, 600);
  }

  /* Sayfadan çıkarken bekleyen gönderimi hemen yap */
  window.addEventListener('pagehide', function () {
    if (syncTimer) { clearTimeout(syncTimer); pushToServer(); }
  });

  /* ─── Giriş sonrası listeleri birleştir ─────────────────────── */
  if (customerId) {
    try {
      var guestItems  = readItems(GUEST_KEY);
      var memberItems = readItems(storageKey);
      var serverItems = sync && Array.isArray(sync.items) ? sync.items : null;
      var pending     = localStorage.getItem(PENDING_KEY) === '1';

      /* Müşteri kaydı esastır; henüz hiç kaydedilmemişse ya da gönderilmemiş
         değişiklik varsa bu tarayıcıdaki üye listesi esas alınır. Misafirken
         eklenenler en üste eklenir. */
      var base   = (serverItems && !pending) ? unionItems(serverItems, []) : memberItems;
      var merged = unionItems(guestItems, base);

      writeItems(storageKey, merged);
      if (guestItems.length) localStorage.removeItem(GUEST_KEY);

      /* Hiç favorisi olmayan üye için boş kayıt oluşturmaya gerek yok */
      var differs = serverItems ? !sameIds(merged, serverItems) : merged.length > 0;
      if (sync && (pending || differs)) scheduleSync();
    } catch (e) { /* sessiz */ }
  }

  /* ─── Değişiklik eventi ───────────────────────────────────── */
  function emitChange(items) {
    var ids = items.map(function (i) { return i.id; });
    document.dispatchEvent(new CustomEvent(EVENT_NAME, {
      detail: { items: items, ids: ids, count: items.length }
    }));
    scheduleSync();
  }

  /* ─── Public API ──────────────────────────────────────────── */
  var Wishlist = {
    getItems:  function () { return readItems(storageKey); },
    getIds:    function () { return readItems(storageKey).map(function (i) { return i.id; }); },
    has: function (productId) {
      var id = String(productId);
      return readItems(storageKey).some(function (i) { return i.id === id; });
    },
    add: function (productId, productHandle, productPrice) {
      var id    = String(productId);
      var items = readItems(storageKey);
      if (!items.some(function (i) { return i.id === id; })) {
        var item = { id: id, handle: productHandle || '', addedAt: Date.now() };
        var price = Number(productPrice);
        if (price > 0) item.price = price;
        items.unshift(item);
        writeItems(storageKey, items);
        emitChange(items);
      }
    },
    remove: function (productId) {
      var id    = String(productId);
      var items = readItems(storageKey).filter(function (i) { return i.id !== id; });
      writeItems(storageKey, items);
      emitChange(items);
    },
    toggle: function (productId, productHandle, productPrice) {
      this.has(productId) ? this.remove(productId) : this.add(productId, productHandle, productPrice);
    },
    /* Kayıtlı listeyi olduğu gibi yazar (sıra ve fiyat bilgisi korunur). */
    setItems: function (items) {
      writeItems(storageKey, items);
      emitChange(items);
    },
    count: function () { return readItems(storageKey).length; }
  };

  window.swistWishlist = Wishlist;

  /* ─── UI: buton görünümünü güncelle ───────────────────────── */
  function updateButtons(ids) {
    document.querySelectorAll('[data-wl-btn]').forEach(function (btn) {
      var isActive = ids.indexOf(String(btn.dataset.wlBtn)) !== -1;
      btn.classList.toggle('wl-btn--active', isActive);
      btn.setAttribute('aria-pressed', String(isActive));
      btn.title = isActive ? 'Favorilerden çıkar' : 'Favorilere ekle';
      var icon = btn.querySelector('.wl-icon');
      if (icon) {
        if (isActive) {
          icon.setAttribute('fill', 'currentColor');
          icon.setAttribute('stroke-width', '0');
        } else {
          icon.setAttribute('fill', 'none');
          icon.setAttribute('stroke-width', '1.8');
        }
      }
    });
  }

  /* ─── UI: sayaçları güncelle ──────────────────────────────── */
  function updateCounters(count) {
    document.querySelectorAll('[data-wl-count]').forEach(function (el) {
      el.textContent = count > 0 ? String(count) : '';
      el.hidden      = count === 0;
    });
    document.querySelectorAll('[data-wl-count-wrap]').forEach(function (el) {
      el.hidden = count === 0;
    });
  }

  /* ─── wishlist:change eventini dinle ──────────────────────── */
  document.addEventListener(EVENT_NAME, function (e) {
    updateButtons(e.detail.ids);
    updateCounters(e.detail.count);
  });

  /* ─── Delegated click handler ─────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wl-btn]');
    if (!btn) return;
    e.preventDefault();
    Wishlist.toggle(btn.dataset.wlBtn, btn.dataset.wlHandle || '', btn.dataset.wlPrice);
  });

  /* ─── Sayfa yüklenince ilk güncelleme ─────────────────────── */
  function onReady() {
    var ids = Wishlist.getIds();
    updateButtons(ids);
    updateCounters(ids.length);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  /* ─── Sonradan gelen kalpler ve sayaçlar ──────────────────────
     Beden seçimi galeriyi, filtre/sonsuz kaydırma kartları yeniden çizer; sunucudan gelen
     kalp hep "boş" gelir. Eklenen her kalbi kayıtlı listeye göre boyar. Boş sepet çekmecesi
     (snippets/swist-cart-empty) şablondan kopyalandığında favori sayacını da doldurur. */
  var LATE_SELECTOR = '[data-wl-btn], [data-wl-count-wrap]';
  var repaintQueued = false;
  new MutationObserver(function (records) {
    if (repaintQueued) return;
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1 && (node.matches(LATE_SELECTOR) || node.querySelector(LATE_SELECTOR))) {
          repaintQueued = true;
          requestAnimationFrame(function () {
            repaintQueued = false;
            var ids = Wishlist.getIds();
            updateButtons(ids);
            updateCounters(ids.length);
          });
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

})();
